


















































































































import Vue from "vue";

import NavigationButton from "@/components/NavigationButton.vue";
import DateInput from "../../../../components/DateInput.vue";
import eventBus from "@/services/eventBus";
import store, { InterfaceStore } from "../../services/InterfaceStore";
import GeneralGetCarsRequestDTO from "../../models/GeneralGetCarsRequestDTO";

interface Data {
  store: InterfaceStore;
  showSendRequestConfirm: boolean;
  /** Belső azonosító (sercar.id) */
  carId: string;
  /** Alvázszám (sercar.bodyno) */
  vin: string;
  fromDate: Date | null;
  toDate: Date | null;
}

interface Methods {
  /** A felületi mezőkből a request DTO — a DTO listás, de a felület egy-egy értéket ad (üres mező → üres lista). */
  buildRequest(): GeneralGetCarsRequestDTO;
  /** Megerősítő sáv — csak akkor nyílik, ha legalább egy szűrő meg van adva. */
  handleShowConfirm(): void;
  sendRequest(): Promise<void>;
}

export default Vue.extend<Data, Methods, {}, {}>({
  name: "CarRequestTool",

  components: {
    NavigationButton,
    DateInput,
  },

  data() {
    return {
      store,
      showSendRequestConfirm: false,
      carId: "",
      vin: "",
      fromDate: null,
      toDate: null,
    };
  },

  methods: {
    buildRequest() {
      const carId = Number(this.carId.trim());
      const vin = this.vin.trim();
      return {
        carIds: this.carId.trim() && Number.isInteger(carId) && carId > 0 ? [carId] : [],
        vins: vin ? [vin] : [],
        syncPeriod: { fromDate: this.fromDate, toDate: this.toDate },
      };
    },

    handleShowConfirm() {
      const request = this.buildRequest();
      const hasFilter = request.carIds.length > 0 || request.vins.length > 0 || !!this.fromDate || !!this.toDate;
      if (!hasFilter) {
        eventBus.$emit("error", "Adjon meg legalább egy szűrési feltételt (belső azonosító, alvázszám vagy intervallum).");
        return;
      }
      this.showSendRequestConfirm = !this.showSendRequestConfirm;
    },

    /**
     * Az összeállított szűrési feltételek elküldése az aktuális interfészre. Interfész-független: a
     * GeneralGetCarsRequestDTO-t a backend változatlanul továbbítja az IfaceSync API-nak, az útvonalat
     * az (interfész, típus) páros adja — pl. Verknél a car/load a köztes táblába tölti a találatokat.
     * Siker után a két lista frissül, a panel bezárul.
     */
    async sendRequest() {
      try {
        await this.store.customDownSyncCars(this.buildRequest());
        this.showSendRequestConfirm = false;
        this.store.showRequestTool = false;
        eventBus.$emit("refreshSyncList");
        eventBus.$emit("refreshSyncErrorList");
      } catch (e) {
        console.error(e);
      }
    },
  },
});
